import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleModal, toggleSpinner, updateMessages } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { getRecipientTypeParam, providerCategories } from 'apps/auth/components/utils/AmplitudeUtils';
import ModalNew from 'apps/auth/components/utils/ModalNew';
import { TRANSFER_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { NETWORK, PAYOUT_COUNTRY, PAYOUT_METHOD, RECIPIENT_TYPE } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { CATEGORY_TRANSFER_TO_CASH_UNITELLER, STATUS_OK } from 'apps/auth/constants/Constants';
import { showActionButtons } from 'apps/auth/helpers/historyUtils';
import { capitalizeFirstLetters } from 'apps/auth/helpers/utils';
import { useCheck, useCheckMeta, useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { GTRestrictionService } from 'apps/auth/services/GTRestrictionService';

import ActionButton from './ActionButton';
import MainButton from './MainButton';

const CheckButtons = (props) => {
    const messages = usePageMessages();
    const extra = useExtra();
    const popupRef = useRef(null);
    const popupFullwidthRef = useRef(null);
    const modalRef = useRef(null);
    const gtRestrictionService = useRef(new GTRestrictionService(messages, popupRef, null, popupFullwidthRef, modalRef));

    const cheque = useCheck();
    const checkMeta = useCheckMeta();
    const { canCancelTransaction } = checkMeta;
    const deliveryMethod = providerCategories[cheque.providerToCategory];

    useEffect(() => {
        gtRestrictionService.current.setActions(props.toggleModal, props.toggleSpinner);
        gtRestrictionService.current.setCheque(checkMeta);
        gtRestrictionService.current.setExtra(extra);
    }, []);

    const sendUnitellerCashPickupAmplitudeEvent = (eventName) => {
        if (cheque?.toBankName) {
            const formattedNetworkName = capitalizeFirstLetters(cheque?.toBankName);
            amplitude.getInstance().logEvent(eventName, {
                [PAYOUT_COUNTRY]: cheque?.toCountry?.nameEn,
                [PAYOUT_METHOD]: deliveryMethod,
                [NETWORK]: formattedNetworkName,
                [RECIPIENT_TYPE]: getRecipientTypeParam(cheque?.recipientType),
            });
        }
    };

    useEffect(() => {
        if (
            __isBrowser__ &&
            cheque?.secretCode !== null &&
            cheque?.providerToCategory === CATEGORY_TRANSFER_TO_CASH_UNITELLER &&
            cheque?.status > 10 &&
            cheque?.status < STATUS_OK
        ) {
            sendUnitellerCashPickupAmplitudeEvent(TRANSFER_SHOWN);
        }
    }, [cheque]);

    return (
        <>
            <MainButton
                toggleSpinner={props.toggleSpinner}
                updateMessages={props.updateMessages}
                toggleChat={props.toggleChat}
                updatePageMessages={props.updatePageMessages}
                popupRef={popupRef}
                modalRef={modalRef}
            />
            {showActionButtons(cheque) && !canCancelTransaction && (
                <ActionButton
                    gtRestrictionService={gtRestrictionService?.current}
                    toggleChat={props.toggleChat}
                    serverError={props.serverError}
                    popupRef={popupRef}
                    modalRef={modalRef}
                />
            )}
            <PopupNew ref={popupRef} getPopupComponent={(component) => component} />
            <PopupNew ref={popupFullwidthRef} fullwidthPopup />
            <ModalNew ref={modalRef} />
        </>
    );
};
CheckButtons.propTypes = {
    deliveryMethodAvailable: PropTypes.bool,
};

export default connect(null, {
    toggleModal,
    toggleSpinner,
    updateMessages,
    updatePageMessages,
    toggleChat,
})(CheckButtons);
